const list = require('./list');
const detail = require('./detail');

const services = () => {
    list();
    detail();
}

module.exports = services